/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import React from "react";
import VmoNoDataChart from "./VmoNoDataChart";
import VmoNoDataTable from "./VmoNoDataTable";
import VmoNoDataGeneral from "./VmoNoDataGeneral";
const VmoNoData = ({ type = "general", ...restProps }) => {
  function _renderLayout() {
    switch (type) {
      case "table":
        return <VmoNoDataTable {...restProps} />;
      case "chart":
        return <VmoNoDataChart {...restProps} />;
      default:
        return <VmoNoDataGeneral {...restProps} />;
    }
  }
  return _renderLayout();
};

export default VmoNoData;
